module.exports = __webpack_public_path__ + "static/bg_black-09bdd96609dc633b70eb3dc6afe7d0ad.mp4";